module.exports = __webpack_public_path__ + "/images/ico-gift-empty.994859d.svg";